import { Component } from '@angular/core';
import { MessageService } from "primeng/api";
import { ApiActiveService } from "@modules/private/active/data/services/api/api-active.service";
import { ACTIVE_COLUMNS } from "@modules/private/active/data/constants/active.constants";
import { ActiveService } from "@modules/private/active/data/services/view/active.service";
import { ACTIONS } from "../data/constants/active.constants";
import { AuthService } from '@data/services/modules/auth/auth.service';

@Component({
  selector: 'app-active-list',
  templateUrl: './active-list.component.html',
  styleUrls: ['./active-list.component.scss'],
  providers: [MessageService]
})
export class ActiveListComponent {
  columns = ACTIVE_COLUMNS
  createEntity = false
  action = 'CREATE'
  additionalMainActions = [{ label: 'Nuevo activo', icon: 'fa-solid fa-square-plus', action: 'CREATE', permission: ['assets', 'create'] as [string, string] }]
  activeList: any[] = [];
  totalRecords = 0;
  loading = true;
  page = 1;
  limit = 10;
  filters = {};
  actions = ACTIONS
  user: string = ''

  constructor(
    public apiActiveService: ApiActiveService,
    public activeService: ActiveService,
    private messageService: MessageService,
    private authService: AuthService
  ) {
    this.user = this.authService.getUser?.user.id || ''
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
  }

  hideDialog() {
    this.createEntity = false;
  }

  mainActions(flow: string) {
    switch (flow) {
      case 'CREATE':
        this.action = 'CREATE'
        this.activeService.newEntity()
        this.activeService.entity.reset()
        this.activeService.entity.patchValue({ banker: this.user })
        this.createEntity = true
        break;
      default:
        console.log(flow)
        break;
    }
  }

  actionMethods(data: {event: any, action: string, data: any}) {
    switch (data.action) {
      case 'EDIT':
        this.activeService.formMethod = 'EDIT'
        this.action = 'EDIT'
        this.activeService.active = data.data
        this.activeService.newEntity()
        this.createEntity = true
        break;
    }
  }

  handleError(error: any) {
    if (error.status === 400 && error.error.data?.errors) {
      const errors = error.error.data.errors;
      errors.forEach((err: any) => {
        this.showErrorMessage(err.msg || 'Por favor revise que los campos estén correctos.');
      });
    } else {
      this.showErrorMessage('Ocurrió un error inesperado al crear el activo.');
    }
  }

  showErrorMessage(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  showSuccessMessage(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: message });
  }


  showFormErrors() {
    Object.keys(this.activeService.entity.controls).forEach((key) => {
      const controlErrors = this.activeService.entity.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          this.showErrorMessage(`Error en el campo ${key}: ${this.getErrorMessage(errorKey, controlErrors[errorKey])}`);
        });
      }
    });
  }

  getErrorMessage(errorKey: string, errorValue: any): string {
    const errorMessages: any = {
      required: 'Este campo es obligatorio.',
      minlength: `El valor ingresado es muy corto. Mínimo ${errorValue.requiredLength} caracteres.`,
      negativeValue: 'El valor no puede ser negativo.',
      onlyLetters: 'Solo se permiten letras.',
    };

    return errorMessages[errorKey] || 'Error en la validación de los datos.'
  }


  saveForm() {
    if (this.activeService.entity.invalid) {
      this.activeService.entity.markAllAsTouched();
      this.showFormErrors();
      return;
    }

    if (this.activeService.formMethod === 'CREATE') {
      const data = this.activeService.entity.value;
      this.apiActiveService.create(data).subscribe(
        (response) => {
          this.loadData();
          this.hideDialog();
          this.showSuccessMessage('El activo fue creado exitosamente.');
        },
        (error) => {
          this.handleError(error);
        }
      );
    } else if (this.activeService.formMethod === 'EDIT') {
      const data = this.activeService.entity.value;
      this.apiActiveService.update(this.activeService.active._id, data).subscribe(
        (response) => {
          this.hideDialog();
          this.showSuccessMessage(`El activo ${this.activeService.active.name} fue actualizado exitosamente.`);
          this.loadData();
        },
        (error) => {
          this.handleError(error);
        }
      );
    }
  }


  onPageChange(event: any) {
    this.page = event.page + 1;
    this.limit = event.rows;
    this.loadData();
  }

  onFilterChange(event: any) {
    this.filters = event.filters;
    this.loadData();
  }
}
